import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog';
import { DialogTitle } from '@radix-ui/react-dialog';
import SwitchAgentIDForm from './switch-agent-id-form';
import { useState } from 'react';

interface SwitchAgentIDModalProps {
  closeNav: () => void;
}

export function SwitchAgentIDModal({ closeNav }: SwitchAgentIDModalProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    closeNav();
  };

  return (
    <div className="p-0 justify-left border-b-1 border-olive-400">
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            variant="text"
            className="no-underline"
            data-ta="open-switch-agent-id-modal"
          >
            Switch Writing code
          </Button>
        </DialogTrigger>
        <DialogContent className="w-[600px] p-7 gap-9">
          <DialogHeader>
            <DialogTitle className="text-left text-blue-900 font-lyon text-10xl border-b-1 border-olive-400">
              Switch Writing code
            </DialogTitle>
          </DialogHeader>
          <SwitchAgentIDForm onSuccess={handleClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
